import React from 'react';
import AsyncComponent from '../../components/AsyncComponent'; // Votre structure
import { GoogleMap, PolygonF, MarkerF } from '@react-google-maps/api';
import { GoogleMapCustomStyle } from '../../utils/GoogleMapCustomStyle';
import './styles.scss';

class PolygonMap extends AsyncComponent {
  constructor(props) {
    super(props);

    this.mapRef = null;
    this.clickListenerRef = null;
    this.mouseMoveListenerRef = null;
    this.tempPointsRef = [];

    this.state = {};
  }

  componentDidUpdate(prevProps) {
    if (prevProps.drawingModeEnabled !== this.props.drawingModeEnabled) {
      if (!this.props.drawingModeEnabled) {
        this._removeMapListeners();
        this.tempPointsRef = [];
      }
      else {
        this.tempPointsRef = [];
        this.props.onZoneCompleted([]);

        if (this.props.onDrawingStatusChange) {
          this.props.onDrawingStatusChange(false);
        }
        this._setupMapListeners();
      }
    }
  }

  componentWillUnmount() {
    this._removeMapListeners();
  }

  _setupMapListeners = () => {
    if (!this.mapRef) return;
    this._removeMapListeners();
    this.mapRef.setOptions({ draggableCursor: 'crosshair' });

    this.clickListenerRef = this.mapRef.addListener('click', (event) => {
      const newPoint = { lat: event.latLng.lat(), lng: event.latLng.lng() };
      this.tempPointsRef = [...this.tempPointsRef, newPoint];
      this.props.onZoneCompleted(this.tempPointsRef);
    });

    this.mouseMoveListenerRef = this.mapRef.addListener('mousemove', (event) => {
      if (this.tempPointsRef.length === 0) return;
      const mousePoint = { lat: event.latLng.lat(), lng: event.latLng.lng() };
      this.props.onZoneCompleted([...this.tempPointsRef, mousePoint]);
    });
  };

  _handleClosePolygon = (e) => {
    if (e && typeof e.stop === 'function') {
      e.stop();
    }
    if (this.tempPointsRef.length >= 3) {
      const finalZone = [...this.tempPointsRef];

      this._removeMapListeners();

      this.props.onZoneCompleted(finalZone);

      if (this.props.onDrawingStatusChange) {
        this.props.onDrawingStatusChange(true);
      }
      this.tempPointsRef = [];
    }
  };

  _removeMapListeners = () => {
    if (this.clickListenerRef) {
      window.google.maps.event.removeListener(this.clickListenerRef);
      this.clickListenerRef = null;
    }
    if (this.mouseMoveListenerRef) {
      window.google.maps.event.removeListener(this.mouseMoveListenerRef);
      this.mouseMoveListenerRef = null;
    }
    if (this.mapRef) {
      this.mapRef.setOptions({ draggableCursor: null });
    }
  };

  _handleMapLoad = (map) => {
    this.mapRef = map;
    if (this.props.drawingModeEnabled) {
      if (this.props.onDrawingStatusChange) {
        this.props.onDrawingStatusChange(false);
      }

      this._setupMapListeners();
    }
  };

  render() {
    const { currentZone, mapCenter, drawingModeEnabled } = this.props;

    return (
      <div className='PolygonMap'>
        <GoogleMap
          mapContainerClassName='map'
          center={mapCenter}
          zoom={12}
          onLoad={this._handleMapLoad}
          options={{
            gestureHandling: drawingModeEnabled ? 'none' : 'greedy',
            streetViewControl: false,
            styles: GoogleMapCustomStyle.mapCustomStyles
          }}
        >
          {drawingModeEnabled && this.tempPointsRef.length >= 3 && (
            <MarkerF
              position={this.tempPointsRef[0]}
              onClick={this._handleClosePolygon}
              options={{
                cursor: 'pointer',
                icon: {
                  path: window.google.maps.SymbolPath.CIRCLE,
                  scale: 7,
                  fillColor: '#6676f7',
                  fillOpacity: 1.0,
                  strokeColor: '#FFFFFF',
                  strokeWeight: 2,
                }
              }}
            />
          )}
          {currentZone && currentZone.length > 0 && (
            <PolygonF
              paths={currentZone}
              options={{
                strokeColor: '#6676f7',
                strokeOpacity: 1.0,
                strokeWeight: 3,
                fillColor: '#6676f7',
                fillOpacity: 0.2,
                clickable: false,
                editable: false,
                draggable: false
              }}
            />
          )}
        </GoogleMap>
      </div>
    );
  }
}

export default PolygonMap;
